import { useState } from "react";
import { validateContactField } from "../registration/registrationValidation";

const CONTACT_FIELDS = ["email", "mobile", "firstName", "lastName", "country"];

const initialContactErrors = {
  email: "",
  mobile: "",
  firstName: "",
  lastName: "",
  country: "",
};

export const useRegistrationContactValidation = ({ formData }) => {
  const [errors, setErrors] = useState(initialContactErrors);

  const validateField = (field, rawValue, overrides = {}) => {
    if (!CONTACT_FIELDS.includes(field)) {
      return true;
    }

    const error = validateContactField(field, rawValue, {
      country: overrides.country ?? formData.country,
      value: overrides.value,
    });
    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAllMandatoryFields = () => {
    const firstNameValid = validateField("firstName", formData.firstName);
    const lastNameValid = validateField("lastName", formData.lastName);
    const emailValid = validateField("email", formData.email);
    const mobileValid = validateField("mobile", formData.mobile, {
      country: formData.country,
      value: formData.mobile,
    });
    const countryValid = validateField("country", formData.country);
    return (
      firstNameValid &&
      lastNameValid &&
      emailValid &&
      mobileValid &&
      countryValid
    );
  };

  return {
    errors,
    setErrors,
    validateField,
    validateAllMandatoryFields,
  };
};
